<template>
  <div class="q-pt-xl" style="max-width: 965px; margin: auto">
    <div class="row q-col-gutter-lg q-px-xl">
      <div class="col-auto">
        <q-avatar size="100px">
          <q-img
            :src="
              userData.profilePictureUrl
                ? userData.profilePictureUrl
                : userData.picture
            "
            contain
          >
          </q-img>
        </q-avatar>
      </div>
      <div class="col">
        <h3 class="settingsHeader q-my-sm">Upload your Picture</h3>
        <p>Image may not exceed 3 MB</p>
        <q-btn
          label="Change Image"
          class="bg-accent text-white"
          no-caps
          flat
          @click="changeImageDialog = true"
        ></q-btn>
        <q-btn
          label="Remove Image"
          class="text-white q-ml-sm"
          color="red"
          no-caps
          flat
          @click="removeImage"
        ></q-btn>
      </div>
    </div>
    <div class="row q-col-gutter-md q-mt-lg">
      <div class="col-6">
        <span class="inputLabel"> Full Name </span>
        <q-input
          filled
          dense
          v-model="userData.fullName"
          :rules="[(v) => !!v || 'Full Name is required']"
          required
        ></q-input>
      </div>
      <div class="col-6">
        <span class="inputLabel"> Phone </span>
        <q-input filled dense v-model="userData.phone" type="number"></q-input>
      </div>
      <div class="col-12">
        <span class="inputLabel"> Contact Email </span>
        <q-input
          filled
          dense
          v-model="userData.email"
          readonly
          :rules="[
            (v) => !!v || 'Contact Email is required',
            (v) => /.+@.+/.test(v) || 'Email must be valid',
          ]"
          required
        ></q-input>
      </div>
      <div class="col-12">
        <span class="inputLabel"> Backup Email </span>
        <q-input filled dense v-model="userData.emailBackup"></q-input>
      </div>
      <div class="col-12">
        <span class="inputLabel"> Bio </span>
        <q-input filled dense v-model="userData.bio" type="textarea"></q-input>
      </div>
      <div class="col-12">
        <q-btn
          class="bg-positive text-white float-right"
          flat
          label="Save Changes"
          no-caps
          @click="save"
          :loading="saveLoading"
        ></q-btn>
      </div>
    </div>
    <q-dialog v-model="changeImageDialog" persistent>
      <q-card
        class="card q-mx-auto"
        style="min-width: 610px; max-width: 610px"
        :style="cssVars"
      >
        <div class="row justify-between items-center q-px-md bg-accent2">
          <div class="text-white" style="font-size: 1rem; font-weight: 700">
            Please Upload an Image
          </div>
          <q-btn
            icon="mdi-close"
            flat
            round
            text-color="white"
            @click="changeImageDialog = false"
          >
          </q-btn>
        </div>
        <div class="row q-pa-md">
          <div class="col-12 text-accent text-center">
            <croppa
              ref="imgCroppa"
              :file-size-limit="3500000"
              :height="150"
              :width="150"
              v-model="myCroppa"
              remove-button-color="#68c6d2"
              :show-loading="true"
              :loading-size="50"
              crossOrigin="anonymous"
              :quality="2"
              :prevent-white-space="false"
              @file-size-exceed="fileSizeExceeded"
            ></croppa>
            <p>Max Size 3mb</p>
          </div>

          <div class="col-12 text-center q-mt-xl">
            <q-btn
              flat
              class="bg-accent text-white"
              style="width: 300px"
              no-caps
              @click="uploadImage"
              :loading="uploading"
            >
              Upload Image
            </q-btn>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters({
      userData: "auth/currentUserData",
    }),
  },
  data: () => ({
    changeImageDialog: false,
    myCroppa: null,
    uploading: false,
    saveLoading: false,
  }),
  mounted() {},
  methods: {
    async uploadImage() {
      if (!this.myCroppa) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "Please select an Image to upload",
        });
        return;
      }

      this.uploading = true;

      let payload = {
        dataUrl: this.myCroppa.generateDataUrl(),
      };

      try {
        let result = await this.$store.dispatch(
          "users/updateProfilePicture",
          payload
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }

      this.uploading = false;
      this.changeImageDialog = false;
      this.myCroppa = null;
    },
    async removeImage() {
      try {
        let result = await this.$store.dispatch(
          "users/updateProfilePicture",
          null
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    fileSizeExceeded(val) {
      this.$q.notify({
        position: "top-right",
        type: "negative",
        message: "The Image must be a max of 3MB",
      });
    },
    async save() {
      this.saveLoading = true;
      try {
        let result = await this.$store.dispatch(
          "users/saveUser",
          this.userData
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
      this.saveLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.settingsHeader {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.7rem;
}
</style>
